import {
  GET_BAZAAR_DETAILS_REQUEST,
  GET_BAZAAR_DETAILS_SUCCESS,
  GET_BAZAAR_DETAILS_FAILURE,
  GET_BAZAAR_DETAILS_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
  data: null,
}

const getBazaarDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BAZAAR_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
        data: null,
      }

    case GET_BAZAAR_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "",
        data: action.payload.data,
      }

    case GET_BAZAAR_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
        data: null,
      }

    case GET_BAZAAR_DETAILS_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default getBazaarDetailReducer
